import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminCard, Badge } from "./AdminLayout";

export default function AdminShipping() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => { api.get("/admin/shipping").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const filtered = filter ? rows.filter((o) => o.status === filter) : rows;
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Shipping Dashboard</h1>
      <div className="flex flex-wrap gap-2 mb-4">
        <button onClick={() => setFilter("")} className={`text-xs uppercase px-3 py-2 border ${!filter ? "bg-sharoa-charcoal text-white" : "border-sharoa-line"}`}>All</button>
        {["confirmed", "packed", "shipped", "in_transit", "out_for_delivery", "delivered"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`text-xs uppercase px-3 py-2 border capitalize ${filter === s ? "bg-sharoa-charcoal text-white" : "border-sharoa-line"}`}>{s.replace(/_/g, " ")}</button>
        ))}
      </div>
      <AdminCard className="overflow-x-auto p-0">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-sharoa-ivory text-left text-xs uppercase text-sharoa-muted"><tr>{["Order", "Customer", "Shipment ID", "AWB", "Courier", "Status", "ETA"].map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr></thead>
          <tbody>
            {filtered.map((o) => (
              <tr key={o.id} className="border-t border-sharoa-line">
                <td className="py-3 px-4 font-mono">{o.order_number}</td>
                <td className="py-3 px-4">{o.customer?.name}</td>
                <td className="py-3 px-4 font-mono">{o.shipment?.shipment_id || "—"}</td>
                <td className="py-3 px-4 font-mono">{o.shipment?.awb || "—"}</td>
                <td className="py-3 px-4">{o.shipment?.courier || "—"}</td>
                <td className="py-3 px-4"><Badge tone={o.status === "delivered" ? "green" : "amber"}>{o.status?.replace(/_/g, " ")}</Badge></td>
                <td className="py-3 px-4">{o.estimated_delivery || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <p className="p-6 text-sharoa-muted text-sm">No shipments.</p>}
      </AdminCard>
    </div>
  );
}
